import React from 'react'
import { NavbarSupportSystem } from "../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../components/share/HeadTitle";
import { ManageCriteriaComponent } from '../../components/SupportSystem/ManageCriteriaComponent'
import { Footer } from "../../components/share/Footer";
export const ManageCriteriaContainer = () => {
    return (
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={"จัดการเกณฑ์การยื่นคำขอเงินช่วยเหลือหรืออุดหนุน"}></HeadTitle>
            <ManageCriteriaComponent />
            <Footer />
        </div>
    )
}
